import React from 'react';

const ViewerContext = React.createContext({});

export default ViewerContext;
